import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Checkbox, Collapse, FormControlLabel, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Palette } from 'Palette';
import { StyledHeading } from '../../styles/styles';
import FundSectorCheckboxes from './FundSectorCheckboxes';
import { FundDetailsFormData } from './fundDetailsFormTypes';
import { FundFinancialFields, FundSiteAndDatesFields } from './FundDetailsFields';

export interface FundDetailsSectionProps {
  formData: FundDetailsFormData;
  fieldErrors?: Record<string, string>;
  onInputChange: (
    field: keyof FundDetailsFormData,
    value: string | number | string[] | boolean,
  ) => void;
  onSectorChange: (sectorValue: FundDetailsFormData['sector'][number]) => void;
}

const FundDetailsSection: React.FC<FundDetailsSectionProps> = ({
  formData,
  fieldErrors,
  onInputChange,
  onSectorChange,
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        onClick={() => setExpanded((prev) => !prev)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          width: 'fit-content',
        }}
      >
        <StyledHeading headerVariant="subheading" sx={{ mb: 0 }}>
          Details
        </StyledHeading>
        {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ mt: 1 }}>
          <FundSectorCheckboxes sector={formData.sector} onSectorChange={onSectorChange} />
        </Box>

        <FundFinancialFields
          formData={formData}
          fieldErrors={fieldErrors}
          onInputChange={onInputChange}
        />
        <FundSiteAndDatesFields
          formData={formData}
          fieldErrors={fieldErrors}
          onInputChange={onInputChange}
        />
        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.excludeFromCustodian || false}
                onChange={(e) => onInputChange('excludeFromCustodian', e.target.checked)}
                sx={{
                  '&.Mui-checked': {
                    color: Palette.default.buttonBg,
                  },
                }}
              />
            }
            label="Exclude from Custodians"
          />
          <Typography variant="caption" sx={{ display: 'block', ml: 4, color: 'text.secondary' }}>
            When enabled, this opportunity will not be visible to custodian users
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
};

export default FundDetailsSection;
